import React from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { getImageUrl } from "src/utils/getImageUrl";
import { Ii18nInterpolationObject } from "src/@types/i18next";
import { CombinedOptionProps } from "./types";

export const Option = ({
  children,
  innerRef,
  data,
  innerProps,
  isSelected,
}: CombinedOptionProps) => {
  const { t } = useTranslation();

  const optionTitle = children as Ii18nInterpolationObject | string;

  const title =
    typeof optionTitle === "string"
      ? optionTitle
      : t(optionTitle.i18nKey, optionTitle.i18nParams);

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className={cn(
        "flex items-center gap-2 h-13.25 px-3 py-5 rounded-20 cursor-pointer hover:bg-black-base/10",
        // This is to see the selected option, in case 'hideSelectedOptions' is set to false in our MultiSelect component
        { "bg-black-base/20": isSelected }
      )}
    >
      {data?.icon && (
        <img src={getImageUrl(data.icon)} alt={title} className="max-h-10" />
      )}
      <span>{title}</span>
    </div>
  );
};
